"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const scale_1 = require("../../utils/scale");
const AutoHeightInput = (props) => {
    const { value, defaultValue = '', style = {}, placeholder = "", placeholderTextColor, maxLength = 191, onChangeText } = props;
    const refInput = (0, react_1.createRef)();
    (0, react_1.useEffect)(() => {
        const element = refInput.current;
        if (react_native_1.Platform.OS === 'web' && !!element) {
            window.requestAnimationFrame(() => {
                element.style.height = '0px';
                element.style.height = `${element.scrollHeight}px`;
            });
        }
    }, [defaultValue]);
    const onChange = (0, react_1.useCallback)((e) => {
        if (react_native_1.Platform.OS !== 'web')
            return;
        window.requestAnimationFrame(() => {
            e.nativeEvent.target.style.height = '0px';
            e.nativeEvent.target.style.height = `${e.nativeEvent.target.scrollHeight}px`;
        });
    }, []);
    return (react_1.default.createElement(react_native_1.TextInput, { ref: refInput, value: value, defaultValue: defaultValue, placeholder: placeholder, placeholderTextColor: placeholderTextColor || "#C8C8C8", style: [{
                minHeight: (0, scale_1.moderateScale)(27),
                fontSize: (0, scale_1.moderateScale)(18),
                lineHeight: (0, scale_1.moderateScale)(27),
                width: "100%",
                fontFamily: 'Hiragino Kaku Gothic Pro W3',
                // @ts-ignore
                outlineWidth: 0,
                overflow: 'hidden'
            }, style], onChange: onChange, textAlignVertical: "center", multiline: true, onChangeText: onChangeText, maxLength: maxLength }));
};
exports.default = AutoHeightInput;
